import { render, staticRenderFns } from "./BoardItems.vue?vue&type=template&id=f9bd5900"
import script from "./BoardItems.vue?vue&type=script&lang=js"
export * from "./BoardItems.vue?vue&type=script&lang=js"
import style0 from "./BoardItems.vue?vue&type=style&index=0&id=f9bd5900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports